import { NgModule } from '@angular/core';
import { DsLibSharedModule } from '../../../shared/ds-lib-shared.module';
import { DsLibMaterialModule } from '../../../shared/ds-lib-material.module';
import { DsLibProfileBarComponent } from './ds-lib-profile-bar.component';
import { DsLibHoverModule } from '../ds-lib-hover/ds-lib-hover.module';

@NgModule({
  declarations: [DsLibProfileBarComponent],
  imports: [DsLibSharedModule, DsLibMaterialModule, DsLibHoverModule],
  exports: [DsLibProfileBarComponent],
})
export class DsLibProfileBarModule {}
